import en from 'vuetify/src/locale/en.ts'

export default {
  ...en,
  action: 'Action',
  preference: 'Preference',
  logout: 'Logout',
  users: 'Users'
}
